import { render, staticRenderFns } from "./UndoInitiateReversal.vue?vue&type=template&id=2889be60&scoped=true&"
import script from "./UndoInitiateReversal.vue?vue&type=script&lang=js&"
export * from "./UndoInitiateReversal.vue?vue&type=script&lang=js&"
import style0 from "./UndoInitiateReversal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UndoInitiateReversal.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./UndoInitiateReversal.vue?vue&type=style&index=2&id=2889be60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2889be60",
  null
  
)

export default component.exports